module.exports = "// Copyright (c) Microsoft. All rights reserved.\r\n// Licensed under the MIT license. \r\n\r\n#ifndef __SHAKE_UI_H__\r\n#define __SHAKE_UI_H__\r\n\r\n#ifdef __cplusplus\r\nextern \"C\"{\r\n#endif // __cplusplus\r\n\r\nvoid DrawAppTitle(char* text);\r\n\r\nvoid DrawShakeAnimation(void);\r\n\r\nvoid DrawCheckBox(int line, int col, int status);\r\n\r\nvoid DrawTweetImage(int line, int col, int status);\r\n\r\n#ifdef __cplusplus\r\n}\r\n#endif // __cplusplus\r\n\r\n#endif // __SHAKE_UI_H__"


//////////////////
// WEBPACK FOOTER
// ./src/data/ShakeShake/ShakeUI.h
// module id = 407
// module chunks = 0